import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import styled from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
import Box from '@magalu/stereo-ui/atoms/Box';
import { StarGroup } from '@magalu/stereo-ui-icons';
export var Content = styled(Box).attrs(function (props) {
  return _extends({
    px: 3
  }, props);
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export var Description = styled(Box).attrs(function (props) {
  return _extends({
    color: 'text.base',
    fontWeight: 'regular',
    lineHeight: 'big',
    textAlign: 'justify'
  }, props);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
export var FeaturesList = styled.ul(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  list-style-type: disc;\n  padding-left: 10px;\n  margin-left: 10px;\n  li {\n    color: ", ";\n    line-height: 1.6;\n  }\n"])), themeGet('colors.darkSilver'));
export var StyledStarGroup = styled(StarGroup)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-right: 8px;\n  color: #0086ff;\n"])));
export var WarningGenAI = {
  alignItems: 'center',
  color: '#697277',
  display: 'flex',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '18px',
  marginBottom: '16px',
  marginTop: '10px'
};